export const TASK_API_BASE = "/TaskManagement";

export const NORMAL_STATUSES = [
  { value: "Open", label: "Open" },
  { value: "InProgress", label: "In Progress" },
  { value: "Closed", label: "Closed" },
];

export const APPROVAL_STATUSES = [
  { value: "Open", label: "Open" },
  { value: "InProgress", label: "In Progress" },
  { value: "Approved", label: "Approved" },
  { value: "Rejected", label: "Rejected" },
];

export const INITIAL_STATE = {
  title: "",
  taskType: "Normal",
  description: "",
  status: "Open",
  assignedTo: "",
  approver: "",
  dueDate: "",
  savedStage: "",
  isMandatory: false,
  referenceTaskId: "",
  notes: "",
  isNotificationRequired: true,
};

export const ALLOWED_FILE_EXTENSIONS = [
  ".xls",
  ".xlsx",
  ".pdf",
  ".svg",
  ".jpg",
  ".jpeg",
  ".png",
  ".doc",
  ".docx",
  ".msg",
  ".eml",
  ".ppt",
  ".pptx",
];

export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

/**
 * Formats file size in human-readable format.
 */
export const formatFileSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
